import { render, staticRenderFns } from "./ModalDeConfirmacaoDePontoSemVoz.vue?vue&type=template&id=661d5b3e&scoped=true&lang=pug"
import script from "./ModalDeConfirmacaoDePontoSemVoz.vue?vue&type=script&lang=js"
export * from "./ModalDeConfirmacaoDePontoSemVoz.vue?vue&type=script&lang=js"
import style0 from "./ModalDeConfirmacaoDePontoSemVoz.vue?vue&type=style&index=0&id=661d5b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661d5b3e",
  null
  
)

export default component.exports